import React from "react";
import { useGetStudentMyCourseQuery} from "../../../Services/api";
import {pageUrl} from "../../../utils/constants/constants";
import { Link } from 'react-router-dom';
import ExpiredCourseModal from "./ExpiredCourseModal";
export default function PaidCourseComp() {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit', 
        day: '2-digit',
    }).split('/').reverse().join('-');
    const {
        data: StudentMyCourse,
        isLoading: isGetLoading,
    } = useGetStudentMyCourseQuery({ pageUrl, params: ''  });
         return(
                <>
                { 
                    StudentMyCourse?.data?.map((item,index) => {   
                        return (
                            <>
                            {(item?.course?.course_type ===1) ? 
                                <div className="col-md-4 col-xs-12 col-sm-12" key={index}>
                                    <div className="card">
                                        <div className="card-header">

                                            {item?.end_date < formattedDate ? 
                                            <button className="dropdown-item"  data-bs-toggle="modal" data-bs-target="#fullscreenModal" >
                                                <img src={item?.course?.course_image} height={200} style={{ width:'100%',height:'15vw','objectFit': 'cover'}} />
                                            </button>
                                            :
                                            <Link to={`/student-course-topic/${item.activity}`}>
                                                <img src={item?.course?.course_image} height={200} style={{ width:'100%',height:'15vw','objectFit': 'cover'}} />
                                            </Link>

                                            }
                                            
                                        </div>
                                        <div className="card-body">
                                            
                                            {item?.end_date < formattedDate ? 
                                                <>
                                                    <button className="dropdown-item"  data-bs-toggle="modal" data-bs-target="#fullscreenModal" >
                                                        <p className='text-warning'>{item?.course?.course_name}</p>
                                                    </button>
                                                    <p>{item?.end_date}</p>
                                                    <ExpiredCourseModal />
                                                </>
                                            
                                            :
                                                <>
                                                    <Link to={`/student-course-topic/${item.activity}`}>
                                                        <p>{item?.course?.course_name}</p>

                                                    <p>Expiry Date: {item?.end_date}</p>
                                                    </Link>
                                                    
                                                </>
                                            }                                            
                                        </div>
                                        
                                    </div>
                                </div> 
                                :
                                ''
                            }
                            </>                                        
                        )
                    })
                }
                </>
            )
     
}
